export const AGES = [5, 6, 7, 8, 9];

export const AgePicker = ({ value, onChange, testid = "age", compact = false }) => (
  <div role="group" aria-label="Child's age" data-testid={`${testid}-picker`} className={`flex flex-wrap ${compact ? "gap-1.5" : "gap-2"}`}>
    {AGES.map((a) => (
      <label key={a} className={`what-age-box ${value === a ? "is-on" : ""} ${compact ? "is-compact" : ""}`}>
        <input type="checkbox" data-testid={`${testid}-${a}`} checked={value === a} onChange={() => onChange(a)} className="sr-only" />
        <span className="what-age-tick" aria-hidden>{value === a ? "✓" : ""}</span>
        {a}{compact ? "" : " years"}
      </label>
    ))}
  </div>
);
